import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import FooterComponent from "../../components/FooterComponent";
import { trackBooked } from "../../utils/metaPixel";
import "./index.css";

class BookingConfirmationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingData: null,
      admin: null,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    let bookingData = location.state?.bookingData || null;
    const admin = location.state?.admin || null;

    if (!bookingData) {
      this.props.history.push("/bookwithus");
      return;
    }

    if (bookingData.passengers && typeof bookingData.passengers === "string") {
      try {
        bookingData.passengers = JSON.parse(bookingData.passengers);
      } catch (e) {
        console.error("Error parsing passengers:", e);
        bookingData.passengers = [];
      }
    }

    this.setState({ bookingData, admin });

    // Track Meta Pixel Booked (Purchase) event
    const grandpriceValue = bookingData.grandprice
      ? parseInt(bookingData.grandprice.replace(/[^0-9]/g, ""), 10)
      : 0;

    trackBooked({
      bookingId: bookingData.bookingId,
      amount: grandpriceValue,
      seats: Array.isArray(bookingData.passengers)
        ? bookingData.passengers.length
        : undefined,
      schedule: bookingData.schedule,
    });
  }

  formatDate = (dateString) => {
    if (!dateString) return { day: "N/A", month: "N/A", time: "N/A" };

    try {
      let date;
      if (dateString.includes("-") && dateString.split("-").length === 3) {
        const parts = dateString.split("-");
        if (parts[0].length === 2) {
          date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        } else {
          date = new Date(dateString);
        }
      } else {
        date = new Date(dateString);
      }

      if (isNaN(date.getTime())) {
        return { day: "N/A", month: "N/A", time: "N/A" };
      }

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      return {
        day: date.getDate(),
        month: months[date.getMonth()],
        time: date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }),
      };
    } catch (e) {
      return { day: "N/A", month: "N/A", time: "N/A" };
    }
  };

  render() {
    const { bookingData, admin } = this.state;

    if (!bookingData) {
      return null;
    }

    const {
      bookingId,
      schedule,
      travelDate,
      seatCount,
      passengers,
      email,
      mobileNumber,
      grandprice,
    } = bookingData;

    const ticketSeatCount = admin?.seats != null ? admin.seats : seatCount;
    const ticketPassengers = passengers;

    const formattedDate = this.formatDate(travelDate);
    const passengerName =
      ticketPassengers && ticketPassengers.length > 0
        ? ticketPassengers[0].name || "Guest"
        : "Guest";

    const scheduleName =
      schedule?.type === "joyride"
        ? schedule.path?.halts?.[0]?.name || "Joy Ride"
        : schedule?.path?.name || "Shuttle";

    return (
      <div className="booking-confirmation-page">
        <div className="ticket-container">
          <div className="ticket-card">
            <div className="ticket-top-section">
              <div className="ticket-content">
                <h1 className="ticket-title">Booking Confirmation</h1>
                <p className="confirmation-message">
                  <span className="highlighted-name">{passengerName}</span> your
                  booking has been confirmed!
                </p>

                <div className="booking-details">
                  <h2 className="venue-name">{scheduleName}</h2>
                  {schedule?.path?.locationLink && (
                    <p className="venue-address">
                      <a
                        href={schedule.path.locationLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="location-link"
                      >
                        View location on Google Maps
                      </a>
                    </p>
                  )}

                  <div className="detail-row">
                    <span className="detail-label">Number of Passengers:</span>
                    <span className="detail-value">
                      {(ticketSeatCount ?? seatCount ?? 1) || 1} People
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Mobile:</span>
                    <span className="detail-value">
                      {mobileNumber || "N/A"}
                    </span>
                  </div>

                  <div className="detail-row">
                    <span className="detail-label">Email:</span>
                    <span className="detail-value">{email || "N/A"}</span>
                  </div>

                  {schedule && schedule.name && (
                    <div className="detail-row">
                      <span className="detail-label">Timings:</span>
                      <span className="detail-value">{schedule.name}</span>
                    </div>
                  )}

                  {ticketPassengers && ticketPassengers.length > 0 && (
                    <div className="passengers-section">
                      <h3 className="passengers-title">Passenger Details</h3>
                      {ticketPassengers.map((passenger, index) => (
                        <div key={index} className="passenger-card">
                          <div className="detail-row">
                            <span className="detail-label">Name:</span>
                            <span className="detail-value">
                              {passenger.name || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Age:</span>
                            <span className="detail-value">
                              {passenger.age || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Weight:</span>
                            <span className="detail-value">
                              {passenger.weight || "N/A"} kg
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Id Type</span>
                            <span className="detail-value">
                              {passenger.documentType || "N/A"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <span className="detail-label">Id Number:</span>
                            <span className="detail-value">
                              {passenger.idNumber || "N/A"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="detail-row amount-row">
                    <span className="detail-label">Total Amount Paid:</span>
                    <span className="detail-value amount-value">
                      {grandprice || "N/A"}
                    </span>
                  </div>
                </div>
              </div>

              <div>
                <div className="date-reference-box">
                  <div className="star-icon">★</div>
                  <div className="date-day">{formattedDate.day}</div>
                  <div className="date-month">{formattedDate.month}</div>
                  <div className="date-time">{formattedDate.time}</div>
                  <div className="reference-divider"></div>
                  <div className="reference-label">Reference No:</div>
                  <div className="reference-number highlighted-booking-id">
                    {bookingId}
                  </div>
                </div>

                <div className="print-button-container">
                  <button
                    className="book-another-button"
                    onClick={() => {
                      this.props.history.push("/bookwithus");
                    }}
                  >
                    Book Another Booking
                  </button>
                </div>
              </div>
            </div>
            <div className="ticket-bottom-section">
              <div className="congratulations-banner">Congratulations!</div>
              <div className="promo-content">
                <div className="promo-left">
                  <div className="promo-message">
                    © {new Date().getFullYear()} Thumby Aviation Pvt. Ltd
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="no-print">
          <FooterComponent />
        </div>
      </div>
    );
  }
}

export default withRouter(BookingConfirmationComponent);
